/* Nanit AU · Sleep schedule generator. Wake-window table mirrors the ranges
   published on the Sleep by Age guide (theme/sections/nanit-sleep-ages.liquid),
   kept as a separate hand-written table here rather than read from the DOM
   so the calculator works even if that section's copy changes independently. */
(function () {
  'use strict';

  var STAGES = [
    { label: '0–3 months',   wakeMin: 45,  wakeMax: 60,  naps: 5, napLen: 45 },
    { label: '4–6 months',   wakeMin: 90,  wakeMax: 150, naps: 4, napLen: 60 },
    { label: '7–9 months',   wakeMin: 150, wakeMax: 180, naps: 3, napLen: 75 },
    { label: '10–12 months', wakeMin: 180, wakeMax: 240, naps: 2, napLen: 90 },
    { label: '1–2 years',    wakeMin: 300, wakeMax: 360, naps: 1, napLen: 120 },
    { label: '2–3 years',    wakeMin: 360, wakeMax: 420, naps: 1, napLen: 90 }
  ];

  function fmtTime(mins) {
    mins = ((mins % 1440) + 1440) % 1440;
    var h = Math.floor(mins / 60), m = mins % 60;
    var ampm = h >= 12 ? 'pm' : 'am';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    return h12 + ':' + (m < 10 ? '0' + m : m) + ampm;
  }

  function fmtWindow(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    if (h === 0) return m + ' min';
    if (m === 0) return h + ' hr' + (h > 1 ? 's' : '');
    return h + 'h ' + m + 'm';
  }

  function build(root) {
    var ageButtons = [].slice.call(root.querySelectorAll('[data-age-index]'));
    var timeInput = root.querySelector('[data-wake-time]');
    var generateBtn = root.querySelector('[data-generate]');
    var output = root.querySelector('[data-output]');
    var timeline = root.querySelector('[data-timeline]');
    var activeIndex = 0;

    ageButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        ageButtons.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        activeIndex = parseInt(btn.getAttribute('data-age-index'), 10) || 0;
      });
    });

    function generate() {
      var stage = STAGES[activeIndex];
      var wakeWindowMid = Math.round((stage.wakeMin + stage.wakeMax) / 2);
      var parts = (timeInput.value || '07:00').split(':');
      var cursor = (parseInt(parts[0], 10) || 7) * 60 + (parseInt(parts[1], 10) || 0);

      var rows = [];
      rows.push({ icon: 'wake', label: 'Wake up', time: fmtTime(cursor) });

      for (var i = 0; i < stage.naps; i++) {
        cursor += wakeWindowMid;
        var napStart = cursor;
        cursor += stage.napLen;
        rows.push({
          icon: 'nap',
          label: 'Nap ' + (stage.naps > 1 ? (i + 1) : ''),
          time: fmtTime(napStart) + ' – ' + fmtTime(cursor)
        });
      }

      cursor += wakeWindowMid;
      rows.push({ icon: 'bed', label: 'Bedtime', time: fmtTime(cursor) });

      timeline.innerHTML = '';
      rows.forEach(function (row) {
        var li = document.createElement('li');
        li.className = 'nau-scheduler__row nau-scheduler__row--' + row.icon;
        li.innerHTML = '<span class="nau-scheduler__rowicon" aria-hidden="true"></span>' +
          '<span class="nau-scheduler__rowlabel">' + row.label + '</span>' +
          '<span class="nau-scheduler__rowtime">' + row.time + '</span>';
        timeline.appendChild(li);
      });

      var note = root.querySelector('[data-output] .nau-scheduler__note');
      if (note) {
        note.textContent = 'Based on a ' + fmtWindow(stage.wakeMin) + '–' + fmtWindow(stage.wakeMax) +
          ' wake window for ' + stage.label + ', using the midpoint. Treat this as a starting point and follow your baby’s own tired cues over the clock.';
      }

      output.hidden = false;
    }

    if (generateBtn) generateBtn.addEventListener('click', generate);

    generate();
  }

  document.querySelectorAll('[data-sleep-scheduler]').forEach(function (root) { build(root); });
})();
